import { Observable } from 'rxjs';
import * as Models from '../../../app/models/models';

export abstract class AbstractServiceNotification {
    abstract askForNotificationSubscription(organizationId: string, campaignId: string, notificationMessage: string): void;
    abstract sendNotifications(sendNotificationParameter: Models.NotificationConfiguration): Observable<Models.ResponseSendNotification>;
    abstract subscribeToNotifications(): void;
}